<template>
  <v-container class="pa-0" :class="{ 'experience-editor-on': isExperienceEditor }">
    <v-row>
      <v-col class="content global-typography" cols="12" lg="8" xs="12">
        <sc-placeholder name="jssmaincolumnleft" :rendering="rendering" />
      </v-col>
      <v-col class="sidebar" cols="12" lg="4" xs="12">
        <sc-placeholder name="jssmaincolumnright" :rendering="rendering" class="row" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'TwoColumnsContent',
  data() {
    return {};
  },
  props: {
    rendering: {
      type: Object,
    },
  },
  computed: {
    isExperienceEditor() {
      return isExperienceEditorActive();
    },
  },
  components: {
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss" scoped>
.experience-editor-on .scEmptyPlaceholder {
  width: 100px;
  height: 50px;
}
.sidebar {
  margin-top: 40px;
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    margin-top: 0px;
    padding-left: 42px !important;
  }
  &::v-deep {
    .row {
      .promo-content-card {
        margin: 12px;
        @media #{map-get($display-breakpoints, 'lg-and-up')} {
          width: 100% !important;
        }
        @media #{map-get($display-breakpoints, 'xs-only')} {
          width: 100% !important;
        }
        @media #{map-get($display-breakpoints, 'sm-and-up')} {
          width: calc(100% / 2 - 24px);
          height: auto !important;
        }
      }
    }
  }
}
</style>
